interface PoolItem<T> {
  item: T;
  weight: number;
}

export class WeightedTable<T> {
  private pool: { [key: string]: PoolItem<T> } = {};
  private weightSum: number = 0;

  public AddItem(itemKey: string, item: T, weight: number) {
    this.pool[itemKey] = { item, weight };
    this.weightSum += weight;
  }

  public RemoveItem(itemKey: string) {
    if (this.pool[itemKey]) {
      this.weightSum -= this.pool[itemKey].weight;
      delete this.pool[itemKey];
    }
  }

  public ModifyWeight(itemKey: string, newWeight: number) {
    if (this.pool[itemKey]) {
      this.weightSum = this.weightSum - this.pool[itemKey].weight + newWeight;
      this.pool[itemKey].weight = newWeight;
    }
  }

  public GetRandomItem(): T | null {
    const rand = Math.random() * this.weightSum;
    let cumulativeWeight = 0;

    for (const key in this.pool) {
      cumulativeWeight += this.pool[key].weight;
      if (rand < cumulativeWeight) {
        return this.pool[key].item;
      }
    }

    return null;
  }
}
